import React from "react";

const ShareIcon = ({color}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M13.3333 11.3092C12.6578 11.3092 12.0533 11.5502 11.5911 11.9277L5.25333 8.59438C5.29778 8.40964 5.33333 8.2249 5.33333 8.03213C5.33333 7.83936 5.29778 7.65462 5.25333 7.46988L11.52 4.16867C12 4.57028 12.6311 4.81928 13.3333 4.81928C14.8089 4.81928 16 3.74297 16 2.40964C16 1.07631 14.8089 0 13.3333 0C11.8578 0 10.6667 1.07631 10.6667 2.40964C10.6667 2.60241 10.7022 2.78715 10.7467 2.97189L4.48 6.27309C4 5.87149 3.36889 5.62249 2.66667 5.62249C1.19111 5.62249 0 6.69879 0 8.03213C0 9.36546 1.19111 10.4418 2.66667 10.4418C3.36889 10.4418 4 10.1928 4.48 9.79116L10.8089 13.1325C10.7644 13.3012 10.7378 13.4779 10.7378 13.6546C10.7378 14.9478 11.9022 16 13.3333 16C14.7644 16 15.9289 14.9478 15.9289 13.6546C15.9289 12.3614 14.7644 11.3092 13.3333 11.3092ZM13.3333 1.60643C13.8222 1.60643 14.2222 1.96787 14.2222 2.40964C14.2222 2.85141 13.8222 3.21285 13.3333 3.21285C12.8444 3.21285 12.4444 2.85141 12.4444 2.40964C12.4444 1.96787 12.8444 1.60643 13.3333 1.60643ZM2.66667 8.83534C2.17778 8.83534 1.77778 8.4739 1.77778 8.03213C1.77778 7.59036 2.17778 7.22892 2.66667 7.22892C3.15556 7.22892 3.55556 7.59036 3.55556 8.03213C3.55556 8.4739 3.15556 8.83534 2.66667 8.83534ZM13.3333 14.4739C12.8444 14.4739 12.4444 14.1124 12.4444 13.6707C12.4444 13.2289 12.8444 12.8675 13.3333 12.8675C13.8222 12.8675 14.2222 13.2289 14.2222 13.6707C14.2222 14.1124 13.8222 14.4739 13.3333 14.4739Z"
        fill={color}
      />
    </svg>
  );
};

export default ShareIcon;
